import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const Tutorial = () => {
  const { type, id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new URL format with query params
    if (type && id) {
      navigate(`/tutorials?type=${type}&id=${id}`, { replace: true });
    } else {
      navigate("/tutorials", { replace: true });
    }
  }, [type, id, navigate]);

  return null;
};

export default Tutorial;
